import { render, staticRenderFns } from "./RoundupListView.vue?vue&type=template&id=b7a48fc0&"
import script from "./RoundupListView.vue?vue&type=script&lang=js&"
export * from "./RoundupListView.vue?vue&type=script&lang=js&"
import style0 from "./RoundupListView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports